/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import MessageBox from 'src/components/Compliance/MessageBox';
import { ROUTES } from 'src/constants/routes';
import BadgeImg from '../../assets/images/FramedImage.png';
import Logomark from '../../assets/images/Logomark.png';
import { resetPurchasePolicy } from '../../redux/actions/purchasePolicy';

const AlreadyCoveragePurchased = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.clear();
    dispatch(resetPurchasePolicy());
  }, []);

  return (
      <ConfirmationWithBackButton
        title="You have already purchased a policy."
        subtitle="Check your inbox for a confirmation email."
        image={BadgeImg}
        goBackLink={ROUTES.LEARN_PATH}
        message={<MessageBox image={Logomark} title="Still have question?"/>}
      />
  );
};

export default AlreadyCoveragePurchased;
